import { useEffect, useMemo, useState } from 'react';

import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';

import { ExpandMore, ChevronRight } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import axios from 'axios';

//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';

//Material UI Imports
import { Card, CardContent, Grid, Box, Typography, Stack, Chip, Skeleton, Paper, Avatar, Button, CircularProgress, IconButton, Alert } from '@mui/material';
import { useOrganization } from '../../context/OrganizationDataContext';
import { useOrganizationSelect } from '../../context/OrganizationSelectContext';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrganizations } from '../../features/Organization/OrganizationSlice';

   


const Organizations = () => {

    const [filteredOrganizations, setFilteredOrganizations] = useState([]);
    const [alert, setAlert] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingRefreshFromPipeHudu, setLoadingRefreshFromPipeHudu] = useState(false);

    const { data: organizations = [], organizationLoading, oraganizationError } = useSelector((state) => state.organizations.organizations);
    const { selectedOrganization } = useOrganizationSelect();


  useEffect(() => {
    if (selectedOrganization) {
      setFilteredOrganizations(organizations.filter(
        (item) => item.name === selectedOrganization
      ));
    } else {
      setFilteredOrganizations(organizations);
    }
  }, [selectedOrganization, organizations]);


  const createHudufromDb = async (organizationId, organizationName) => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/organizations/createHuduFromDB/${organizationId}`);
      if (response.status === 200 || response.status === 201) {
        // Optionally, you can show a success message or update the UI
        console.log("Création dans Hudu réussie pour l'organisation :", organizationId);
        // Refresh organizations after creating Hudu
        dispatch(fetchOrganizations());
        setAlert({
          type: 'success',
          message: `Création dans Hudu réussie pour l'organisation: ${organizationName}`,
        });
        setLoading(false);
      }

    } catch (error) {
      console.error('Error creating Hudu from DB:', error);
    }


  }




    const columns = useMemo(
      () => [
      {
        id: 'clients', //id used to define `group` column
        columns: [
        {
          accessorFn: (row) => row.name, //accessorFn used to join multiple data into a single cell
          id: 'name', //id is still required when using accessorFn instead of accessorKey
          header: 'Nom',
          size: 250,
          Cell: ({ renderedCellValue, row }) => (
          <Box
            sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            }}
          >{renderedCellValue}
          </Box>
          ),
          filterVariant: 'autocomplete',
        },
        {
          accessorFn: (row) => row.parentOrganization?.name, //accessorFn used to join multiple data into a single cell
          id: 'parentOrganization', //id is still required when using accessorFn instead of accessorKey
            header: 'Parent Organization',
            size: 250,
            Cell: ({ renderedCellValue, row }) => (
            <Box
              sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              }}
            >
              {renderedCellValue}
            </Box>
            ),
            filterVariant: 'autocomplete',
            },
            {
            accessorFn: (row) => row.rootOrganization?.name,
            id: 'rootOrganization',
            header: 'Root Organization',
            size: 250,
            Cell: ({ renderedCellValue, row }) => (
            <Box
              sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              }}
            >
              {renderedCellValue}
            </Box>
            ),
            filterVariant: 'autocomplete',
            },
            {
            accessorFn: (row) => row.pipedrive_id ? "Oui" : "Non",
            id: 'pipedrive',
            header: 'Pipedrive',
            size: 80,
            Cell: ({ row }) => (
            <Box
              sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              }}
            >
              {row.original.pipedrive_id ? (
              <DoneIcon color="success" />
              ) : (
              <ClearIcon color="error" />
              )}
            </Box>
            ),
            filterVariant: 'autocomplete',
            },
            {
            accessorFn: (row) => row.hudu_id ? "Oui" : "Non",
            id: 'hudu',
            header: 'Hudu',
            size: 120,
            Cell: ({ row }) => (
              <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
              }}
              >
              {row.original.hudu_id ? (
                <DoneIcon color="success" />
              ) : (
                <>
                <ClearIcon color="error" />
                {loading ? (
                  <CircularProgress size={20} />
                ) : (
                <IconButton
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => createHudufromDb(row.original._id, row.original.name)}
                >
                  <AddIcon />
                </IconButton>
                )}
                </>
              )}
              </Box>
            ),
            filterVariant: 'autocomplete',
            },
            {
            accessorFn: (row) => row.infogerance ? "Yes" : "No", // Directly use the array
          id: 'infogerance', // id is required
          header: 'Infogérance',
          size: 40,
          Cell: ({ row }) => (
            <Box
            sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            }}
            >
            {row.original.infogerance ? (
            <DoneIcon color="success" />
            ) : (
            <ClearIcon color="error" />
            )}
            </Box>
          ),
          filterVariant: 'autocomplete',
          },
          {
          accessorFn: (row) => row.o365Licenses && row.o365Licenses.length > 0 ? "Yes" : "No", // Directly use the array
          id: 'o365Licenses', // id is required
          header: 'O365',
          size: 40,
          Cell: ({ row }) => (
            <Box
            sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            }}
            >
            {row.original.o365Licenses && row.original.o365Licenses.length > 0 ? (
            <DoneIcon color="success" />
            ) : (
            <ClearIcon color="error" />
            )}
            </Box>
          ),
          filterVariant: 'autocomplete',
          },
          {
          accessorFn: (row) => row.esetLicenses && row.esetLicenses.length > 0 ? "Yes" : "No", // Directly use the array
          id: 'esetLicenses', // id is required
          header: 'ESET',
          size: 40,
          Cell: ({ row }) => (
            <Box
            sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            }}
            >
            {row.original.esetLicenses && row.original.esetLicenses.length > 0 ? (
            <DoneIcon color="success" />
            ) : (
            <ClearIcon color="error" />
            )}
            </Box>
          ),
          filterVariant: 'autocomplete',
          },
          {
          accessorFn: (row) => row.vbo365Licenses && row.vbo365Licenses.length > 0 ? "Yes" : "No", // Directly use the array
          id: 'vbo365Licenses', // id is required
          header: 'Veeam Backup O365',
          size: 40,
          Cell: ({ row }) => (
            <Box
            sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            }}
            >
            {row.original.vbo365Licenses && row.original.vbo365Licenses.length > 0 ? (
            <DoneIcon color="success" />
            ) : (
            <ClearIcon color="error" />
            )}
            </Box>
          ),
          filterVariant: 'autocomplete',
          },
          
   
      
        ]}
      ],
      [],
    );
    
  
    const table = useMaterialReactTable({
      columns,
      data: filteredOrganizations ? filteredOrganizations : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
      enableColumnFilterModes: true,
      enableColumnOrdering: true,
      enableGrouping: true,
      enableColumnPinning: true,
      enableFacetedValues: true,
      initialState: {
        density: 'compact',
        // showColumnFilters: true,
        // showGlobalFilter: true,
        columnPinning: {
          left: ['mrt-row-expand', 'mrt-row-select'],
          right: ['mrt-row-actions'],
        },
      },
      paginationDisplayMode: 'pages',
      positionToolbarAlertBanner: 'bottom',
      muiSearchTextFieldProps: {
        size: 'small',
        variant: 'outlined',
      },
      muiPaginationProps: {
        color: 'secondary',
        rowsPerPageOptions: [10, 20, 30],
        shape: 'rounded',
        variant: 'outlined',
      },
      
    });

    const [treeData, setTreeData] = useState([]);

  // Fonction pour construire l'arbre depuis la liste plate
  // const buildTree = (list) => {
  //   const map = {};
  //   list.forEach(org => {
  //     map[org._id] = { ...org, children: [] };
  //   });

  //   const roots = [];

  //   list.forEach(org => {
  //     if (org.organizationParent) {
  //       if (map[org.organizationParent]) {
  //         map[org.organizationParent].children.push(map[org._id]);
  //       }
  //     } else {
  //       roots.push(map[org._id]);
  //     }
  //   });

  //   return roots;
  // };

const buildTree = (list) => {
  const map = {};
  list.forEach(org => {
    map[String(org._id)] = { ...org, children: [], relatedNodes: [] };
  });

  // Hiérarchie parent/enfant
  list.forEach(org => {
    if (org.organizationParent) {
      const parentId = String(org.organizationParent);
      if (map[parentId]) {
        map[parentId].children.push(map[String(org._id)]);
      }
    }
  });

  // Ajouter les related (même logique qu'un champ unique, mais on prépare un tableau)
  list.forEach(org => {
    if (org.organizationRelated) {
      const relatedId = String(org.organizationRelated);
      if (map[relatedId]) {
        map[relatedId].relatedNodes.push(map[String(org._id)]);
      }
    }
  });

  // Racines = celles qui ne sont pas enfant et pas related
  const roots = list
    .filter(org => !org.organizationParent && !org.organizationRelated)
    .map(org => map[String(org._id)]);

  return roots;
};


    useEffect(() => {
        if (filteredOrganizations && filteredOrganizations.length > 0) {
          const tree = buildTree(filteredOrganizations);
          setTreeData(tree);
        }
      }, [filteredOrganizations]);



    // const renderTree = (nodes) => (
    //     nodes.map(node => (
    //       <TreeItem key={node._id} itemId={String(node._id)} label={node.name}>
    //         {node.children.length > 0 && renderTree(node.children)}
    //       </TreeItem>
    //     ))
    //   );


const renderTree = (nodes, prefix = '') =>
  nodes.map(node => (
    <TreeItem
      key={`${prefix}${node._id}`}
      itemId={`${prefix}${node._id}`}
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {/* Nom principal */}
          <Typography>{node.name}</Typography>

          {/* Related affichés à droite */}
          {node.relatedNodes.length > 0 && (
            <Stack direction="column" spacing={1} sx={{ ml: 4 }}>
              {node.relatedNodes.map(rel => (
                <Box
                  key={`${rel._id}-related`}
                  sx={{
                    display: 'flex',
                 
                    alignItems: 'center',
                    gap: 1,
                    p: 0.5,
                    borderRadius: 1,
                    bgcolor: 'rgba(33, 150, 243, 0.1)',
                  }}
                >
                  <Chip label="Related" size="small" color="info" />
                  <Typography variant="body2">{rel.name}</Typography>
                </Box>
              ))}
            </Stack>
          )}
        </Box>
      }
    >
      {/* Enfants directs */}
      {node.children.length > 0 && renderTree(node.children, prefix)}
    </TreeItem>
  ));




      const dispatch = useDispatch();




      const RefreshPipeHudu = async () => {

        try {

          setLoadingRefreshFromPipeHudu(true)
            const syncPipedrive = await axios.get(`${process.env.REACT_APP_API_URL}/api/organizations/syncpipedrive`);
            if (syncPipedrive.status === 200) {
            // await new Promise(resolve => setTimeout(resolve, 6000));
            const GetHuduOrg = await axios.get(`${process.env.REACT_APP_API_URL}/api/organizations/setOrganizationToHudu`);
            if (GetHuduOrg.status === 200) {
              // await new Promise(resolve => setTimeout(resolve, 6000));
              const deduplicate = await axios.get(`${process.env.REACT_APP_API_URL}/api/organizations/deduplicate`);
              if (deduplicate.status === 200) {
                setLoadingRefreshFromPipeHudu(false)

                dispatch(fetchOrganizations()); // chargement initial
                window.location.reload();
              // await new Promise(resolve => setTimeout(resolve, 4000));
              }
              // return [syncPipedrive.data, GetHuduOrg.data, deduplicate.data];
            }
            // return [syncPipedrive.data, GetHuduOrg.data, null];
            }
            // return [syncPipedrive.data, null, null];

          
          // Dispatch an action to refresh organizations in Redux after API calls
          // (Assuming you have a Redux action called fetchOrganizations)
          // import { useDispatch } from 'react-redux'; at the top of your file
          // Then here:
          // dispatch(fetchOrganizations());
        } catch (error) {
          console.error('Error fetching URLs:', error);
          return [null, null];
        }
      };
  
  
    return (
    <Box>{filteredOrganizations && filteredOrganizations.length > 0 ? 
      (<Box>
        <Typography variant="h6" my={1}>
          Clients
        </Typography>
      
      <Box sx={{ mb: 2 }}>
        <Grid container spacing={2} alignContent={'center'}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card sx={{ p: 1, mt:2, borderRadius: 3}}>
              <Box display={'flex'} alignItems={'center'} my={1} mx={2} columnGap={1}>
                <Avatar sx={{ bgcolor: 'primary.main' }}>
                  <DeviceHubIcon />
                </Avatar>
                <Typography variant="h6" >Organigramme</Typography>
              </Box>
              <SimpleTreeView>
                  {renderTree(treeData)}
              </SimpleTreeView>
            </Card>
          </Grid>
          {/* <Grid size={{ xs: 12, md: 6 }}>
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">Nombre de clients : {organizations.length}</Typography>
              </CardContent>
            </Card>
          </Grid> */}
        </Grid>
      </Box>
      <Box>
        <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
          Liste des clients
        </Typography>
        {/* <Box display={'flex'} alignContent={'center'} >
          <Button variant='outlined' onClick={() => RefreshPipeHudu()} sx={{mb:2}} disabled={loadingRefreshFromPipeHudu && true}>Refresh PLE</Button>
          {loadingRefreshFromPipeHudu && (
            <Box sx={{ display: 'flex', justifyContent: 'center', ml: 2 }}>
              <CircularProgress size={30} />
            </Box>
          )}

        </Box> */}
        {alert && (
          <Box sx={{ mb: 2 }}>
            <Alert variant="filled" severity={alert.type === 'success' ? 'success' : 'error'}>
               {alert.message}
            </Alert>
          </Box>
        )}
      <MaterialReactTable table={table} />
      </Box>
      </Box> ) : (
        <Box>
          <Skeleton variant="text" width={260} sx={{ fontSize: '3rem' }} />
          <Skeleton variant="text" width={200} sx={{ fontSize: '2rem' }} />
          <Grid container spacing={2} alignContent={'center'}>
            <Grid size={{ xs: 6, md: 4 }}>
              <Skeleton variant="rectangular" width={'100%'} height={200} />
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Skeleton variant="rectangular" width={'100%'} height={200} />
            </Grid>
             <Grid size={{ xs: 6, md: 4 }}>
              <Skeleton variant="rectangular" width={'100%'} height={200} />
            </Grid>
          </Grid>  
          <Skeleton variant="text" width={200} sx={{ fontSize: '2rem' }} />
          <Skeleton variant="rectangular" width={'100%'} height={600} />

        </Box>
        
      )}
    </Box>
    

);

};

export default Organizations;
